module.exports = __webpack_public_path__ + "files/b8a4fef1f3b9f30b833b9b61567bdf91.png";